/**
 * WS channel-name helpers shared by producer (api/worker publish sites) and
 * consumer (web subscribe sites), so the two sides can't drift — the same
 * contract `userChannel` (directed-notes.ts) established for the per-user
 * channel. Add a helper here the first time a channel name gains a
 * cross-package producer/consumer pair; single-sided names can stay inline.
 */
/**
 * The per-batch progress channel. Producer: workflow-engine's
 * publishBatchProgress (BATCH_PROGRESS after each document advance).
 * Consumers subscribe explicitly (ws-subscribe-policy allows any
 * authenticated tenant member — no tenant segment to gate on).
 */
export function batchChannel(batchId) {
    return `batch:${batchId}`;
}
//# sourceMappingURL=ws-channels.js.map